import React, { useState, useEffect, useRef } from "react";
import { Tabs, Tab, Row, Col, Nav, Button } from 'react-bootstrap';
import { Modal} from 'antd';
import "../../App.css";
import "./RateQuote.css";
import { withRouter } from "react-router-dom";
import RateQuoteLOVersion from "./RateQuoteLOVersion";
import RateQuoteLONewVersion from "./RateQuoteLONewVersion"
import RateQuoteBorrowerVersion from "./RateQuoteBorrowerVersion"
import { checkAccess } from "../../Auth";
import { UR_PriceEngineUser, UR_Owner } from "../../State";
import Lenders from "../../Management/Lenders";

const RateQuoter = (props) => {
  const [showAddLenderModal, setShowAddLendersModal] = useState(false);
  const [switchkey, setSwitchkey] = useState("loVersion");
  const isMobile = window.innerWidth <576
  if (checkAccess([UR_PriceEngineUser])) {
    return  <RateQuoteLONewVersion />
  }

  var currentUrl = window.location.href;
  const isGMCCCelebrity = currentUrl.includes("gmcccelebrityrates") || props.isGMCCCelebrity
  const specificProgram = (isGMCCCelebrity || props.isGMCCCelebrity) ? "GMCCCelebrities" : undefined


  let content = 
    <Tab.Container defaultActiveKey="loVersion" onSelect = {(activekey)=>setSwitchkey(activekey)}>
    <Row style={{borderBottom:"1px solid #DBDCDE",height: 62, alignItems:"center"}}>
      <Col xs={6} style={{paddingLeft: 26}}>
        {!isMobile && <div style={{fontWeight: 500,textAlign:"left",fontSize:"18px", color: '#222'}}>Rates</div>}
      </Col>
      {!isGMCCCelebrity &&       <Col xs={6}>
        <Nav style={{justifyContent:"right",paddingRight: isMobile?"0":"20px", fontFamily: 'Inter'}} >
          <Nav.Item className="d-flex">
            {switchkey === "borrowerVersion" && 
              <Nav.Link style={{backgroundColor:"#F6F6F6",display:"flex",padding: 3,alignItems:"center", gap: 4, borderRadius:"4px", height: 46}} eventKey="loVersion">
                <div style={{ width: 130, height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize:"14px", color:"#222222"}}>LO version</div>
                <div style={{ width: 130, height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor:"#FFFFFF", borderRadius: 4, fontSize:"14px",fontWeight: 500,color:"#222", boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.06)'}}>Borrower version</div>
              </Nav.Link>
            }
            {switchkey === "loVersion" && 
              <Nav.Link style={{backgroundColor:"#F6F6F6",display:"flex",padding: 3,alignItems:"center", gap: 4, borderRadius:"4px", height: 46}} eventKey="borrowerVersion">
                <div style={{width: 130, height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor:"#FFFFFF", borderRadius: 4, fontSize:"14px",fontWeight: 500,color:"#222", boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.06)'}}>LO version</div>
                <div style={{width: 130, height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize:"14px", color:"#222222"}}>Borrower version</div>
              </Nav.Link>
            }
            {checkAccess([UR_Owner]) && <Button variant="addLenders" className="addLendersBtn"  onClick={()=>setShowAddLendersModal(true)}>Add lenders</Button>}
          </Nav.Item>
        </Nav>  
      </Col>}

    </Row>
    
    <Tab.Content style={{height: 'calc(100vh - 62px)'}}>
          <Tab.Pane className="h-100" eventKey="loVersion"><RateQuoteLONewVersion isMobile={isMobile} specificProgram={specificProgram} /></Tab.Pane>
          <Tab.Pane className="h-100" eventKey="borrowerVersion"><RateQuoteBorrowerVersion fromLOS={true}/></Tab.Pane>
    </Tab.Content>
    
    <Modal
      open={showAddLenderModal}
      onCancel={()=>setShowAddLendersModal(false)}
      centered
      footer={[
        <Button key="back" onClick={()=>setShowAddLendersModal(false)}>
          Cancel
        </Button>,
      ]}
      width={1000}
    >
      <Lenders />
    </Modal>
    </Tab.Container>

  return content
}

export default withRouter(RateQuoter);
